/** 입력 중에 실시간으로 모양을 잡아 주는 함수들. 부분 입력 상태에서도 자연스러워야 한다. */

/**
 * 연락처 자동 하이픈.
 *  02-123-4567 / 02-1234-5678 / 010-1234-5678 / 031-123-4567 / 1544-3230
 */
export function formatPhone(value) {
  const d = String(value ?? '').replace(/\D/g, '').slice(0, 11);
  if (!d) return '';

  // 서울 지역번호는 2자리
  if (d.startsWith('02')) {
    if (d.length <= 2) return d;
    if (d.length <= 5) return `${d.slice(0, 2)}-${d.slice(2)}`;
    if (d.length <= 9) return `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}`;
    return `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6, 10)}`;
  }

  // 15xx·16xx·18xx 대표번호는 8자리
  if (/^1[5678]/.test(d) && d.length <= 8) {
    return d.length <= 4 ? d : `${d.slice(0, 4)}-${d.slice(4)}`;
  }

  if (d.length <= 3) return d;
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
  if (d.length <= 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7, 11)}`;
}

/** 금액 천단위 구분. 숫자만 남기고 3자리마다 쉼표를 넣는다. */
export function formatThousands(value) {
  const d = String(value ?? '').replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, 12);
  if (!d) return '';
  return Number(d).toLocaleString('ko-KR');
}

/** 영어가 섞인 문구는 브라우저 자동번역에서 빼 둔다 — `translate={noTranslate(text)}` */
export function noTranslate(text) {
  return /[A-Za-z]/.test(String(text ?? '')) ? 'no' : undefined;
}
